// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main page container */
.page {
    padding-top: 5rem;
    max-width: 1000px;
    margin: 0 auto;
    font-family: "Ubuntu", sans-serif;
    font-weight: 500;
    font-style: normal;
    text-align: center;
}

/* Page title */
.page-title {
    background-color: #eee7d7; 
    color: white; 
    padding: 0.5rem 1rem; 
    border-radius: 8px;
    font-size: medium;
}

/* Page title */
.page-list {
    list-style: none;
    padding: 1rem;
    font-size: small;
}

/* Category text */
.page-category {
    text-align: left; 
    margin-bottom: 1rem;
}

/* Individual page item */
.page-item {
    background: #f9f9f9;
    margin-bottom: 1rem;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: left;
    font-size: medium;
    color: #000;
    text-align: justify;
}

/* Styling paragraph */
.page-item normal {
    text-align: center;
}

/* Styling for H2 */
.page-item h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #000;
    text-align: left;
}

/* Styling for H3 */
.page-item h3 {
    margin: 0;
    font-size: 1rem;
    color: #000;
    text-align: left;
}

/* Link styling */
.page-link {
    color: #007bff;
    text-decoration: underline;
    position: relative;    
}

.page-link-hover {
    color: #007bff;
    text-decoration: underline;
    position: relative;    
}

/* Hover effect for links */
.page-link:hover {
    text-decoration: underline;
}


/* Tooltip container */
.page-link-hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translateX(-50%);
    margin-bottom: 10px;
    padding: 5px 10px;
    background-color: #333;
    color: #fff;
    font-size: 0.75rem;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0.2s;
    z-index: 1;
}

/* Show the tooltip when hovering */
.page-link-hover:hover::after {
    opacity: 1;
    visibility: visible;
}

/* Architecture container */
.architecture-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

/* Architecture image */
.architecture-img {
    max-width: 100%;
    height: auto;
    border-radius: 0;
    text-align: center;
}

/* Figure styling */
figure {
    margin: 0;
}

/* Figure caption */
figcaption {
    margin-top: 10px;
    font-size: medium;
    color: #666;
    text-align: center;
}

/* Left-aligned figure caption */
.figcaptionLeft {
    font-size: smaller;
    color: #666;
    text-align: left;
    align-self: flex-start;
    width: 100%;
    padding-left: 20px;
}

/* Poney detail container */
.poney-detail {
    display: flex;
    align-items: center;
    background: #f9f9f9;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: left;
}

/* Poney image */
.poney-img {
    max-width: 50px; 
    height: auto;
    margin-right: 10px; 
}

/* Poney information */
.poney-info {
    display: flex;
    flex-direction: column;
}

.page-banner {
    padding-top: 5rem;
    max-width: 1100px;
    margin: 0 auto;
    font-family: "Ubuntu", sans-serif;
    font-weight: 500;
    font-style: normal;
    text-align: center;
}

.page-home {
    /* padding-top: 5rem; */
    max-width: 1000px;
    margin: 0 auto;
    font-family: "Ubuntu", sans-serif;
    font-weight: 500;
    font-style: normal;
    text-align: center;
}

/* Banner image */
.banner{
    width: 100%;
    height: auto;
    margin-bottom: 5rem;
}

.rotating {
    animation: rotate 1s infinite alternate; 
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(-20deg);
    }
    100% {
        transform: rotate(20deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/page.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI,0BAA0B;AAC9B;;;AAGA,sBAAsB;AACtB;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;AACd;;AAEA,mCAAmC;AACnC;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Main page container */\n.page {\n    padding-top: 5rem;\n    max-width: 1000px;\n    margin: 0 auto;\n    font-family: \"Ubuntu\", sans-serif;\n    font-weight: 500;\n    font-style: normal;\n    text-align: center;\n}\n\n/* Page title */\n.page-title {\n    background-color: #eee7d7; \n    color: white; \n    padding: 0.5rem 1rem; \n    border-radius: 8px;\n    font-size: medium;\n}\n\n/* Page title */\n.page-list {\n    list-style: none;\n    padding: 1rem;\n    font-size: small;\n}\n\n/* Category text */\n.page-category {\n    text-align: left; \n    margin-bottom: 1rem;\n}\n\n/* Individual page item */\n.page-item {\n    background: #f9f9f9;\n    margin-bottom: 1rem;\n    padding: 1rem;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    text-align: left;\n    font-size: medium;\n    color: #000;\n    text-align: justify;\n}\n\n/* Styling paragraph */\n.page-item normal {\n    text-align: center;\n}\n\n/* Styling for H2 */\n.page-item h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #000;\n    text-align: left;\n}\n\n/* Styling for H3 */\n.page-item h3 {\n    margin: 0;\n    font-size: 1rem;\n    color: #000;\n    text-align: left;\n}\n\n/* Link styling */\n.page-link {\n    color: #007bff;\n    text-decoration: underline;\n    position: relative;    \n}\n\n.page-link-hover {\n    color: #007bff;\n    text-decoration: underline;\n    position: relative;    \n}\n\n/* Hover effect for links */\n.page-link:hover {\n    text-decoration: underline;\n}\n\n\n/* Tooltip container */\n.page-link-hover::after {\n    content: attr(data-tooltip);\n    position: absolute;\n    left: 50%;\n    bottom: 100%;\n    transform: translateX(-50%);\n    margin-bottom: 10px;\n    padding: 5px 10px;\n    background-color: #333;\n    color: #fff;\n    font-size: 0.75rem;\n    border-radius: 4px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.2s, visibility 0.2s;\n    z-index: 1;\n}\n\n/* Show the tooltip when hovering */\n.page-link-hover:hover::after {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* Architecture container */\n.architecture-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n}\n\n/* Architecture image */\n.architecture-img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 0;\n    text-align: center;\n}\n\n/* Figure styling */\nfigure {\n    margin: 0;\n}\n\n/* Figure caption */\nfigcaption {\n    margin-top: 10px;\n    font-size: medium;\n    color: #666;\n    text-align: center;\n}\n\n/* Left-aligned figure caption */\n.figcaptionLeft {\n    font-size: smaller;\n    color: #666;\n    text-align: left;\n    align-self: flex-start;\n    width: 100%;\n    padding-left: 20px;\n}\n\n/* Poney detail container */\n.poney-detail {\n    display: flex;\n    align-items: center;\n    background: #f9f9f9;\n    padding: 1rem;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    text-align: left;\n}\n\n/* Poney image */\n.poney-img {\n    max-width: 50px; \n    height: auto;\n    margin-right: 10px; \n}\n\n/* Poney information */\n.poney-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.page-banner {\n    padding-top: 5rem;\n    max-width: 1100px;\n    margin: 0 auto;\n    font-family: \"Ubuntu\", sans-serif;\n    font-weight: 500;\n    font-style: normal;\n    text-align: center;\n}\n\n.page-home {\n    /* padding-top: 5rem; */\n    max-width: 1000px;\n    margin: 0 auto;\n    font-family: \"Ubuntu\", sans-serif;\n    font-weight: 500;\n    font-style: normal;\n    text-align: center;\n}\n\n/* Banner image */\n.banner{\n    width: 100%;\n    height: auto;\n    margin-bottom: 5rem;\n}\n\n.rotating {\n    animation: rotate 1s infinite alternate; \n}\n\n@keyframes rotate {\n    0% {\n        transform: rotate(0deg);\n    }\n    50% {\n        transform: rotate(-20deg);\n    }\n    100% {\n        transform: rotate(20deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
